import React from 'react';
import DropdownTreeSelect, { DropdownTreeSelectProps } from 'react-dropdown-tree-select';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';
import { treeSelectStyles } from './TreeSelect.styles';

import 'react-dropdown-tree-select/dist/styles.css';

import { ValidationError } from 'helpers/validationRules';

// All styling moved to TreeSelect.styles.ts and applied via MUI sx props

interface ITreeSelectProps extends DropdownTreeSelectProps {
  label: string;
  userScope: string[];
  error?: ValidationError | false;
  isPartiallySelectedTree?: boolean;
}

const TreeSelect = React.memo((props: ITreeSelectProps) => {
  const { t } = useTranslation();
  const { label, userScope, error, isPartiallySelectedTree, ...rest } = props;
  const renderedValue = userScope.map((e, i) => <div key={i}>{e}</div>);

  if (isPartiallySelectedTree) {
    return (
      <Box sx={treeSelectStyles.dropdownWrapper}>
        <DropdownTreeSelect {...rest} showPartiallySelected />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        ...treeSelectStyles.container,
        '& .rendered-value': {
          ...treeSelectStyles.container['& .rendered-value'],
          color: renderedValue.length ? '#354052' : 'rgba(0, 0, 0, 0.54)',
        },
      }}
      className={error ? 'error' : ''}>
      <div className="label">{renderedValue.length ? label : ''}</div>
      <div className="rendered-value">{renderedValue.length ? renderedValue : label}</div>
      <Box sx={treeSelectStyles.dropdownWrapper}>
        <DropdownTreeSelect {...rest} />
      </Box>
      <FormHelperText error>{error && t(error.key, error.values)}</FormHelperText>
    </Box>
  );
});

export default TreeSelect;
